/**
 * Resolves a stored image reference to an absolute URL the browser can load.
 *
 * - "https://..."              → returned as-is (R2 uploads, external CDN, etc.)
 * - "bg/default_1.jpg"        → ${VITE_DEFAULT_IMAGES_URL}/<stored>
 * - "fpv_flower/...", "fpv_ring/..." → same prefix
 * - unknown shape              → returned as-is (graceful fallback)
 *
 * The default image base URL is `VITE_DEFAULT_IMAGES_URL` (configured per env).
 * In dev it points to the backend's `/static-defaults` mount; in prod it
 * points to the same origin via the deployed backend.
 */
const BASE = (import.meta.env.VITE_DEFAULT_IMAGES_URL as string | undefined)
  || '/static-defaults';

export function resolveAssetUrl(stored: string | null | undefined): string {
  if (!stored) return '';
  if (/^https?:\/\//.test(stored)) return stored;
  if (/^(bg|fpv_flower|fpv_ring)\//.test(stored)) {
    return `${BASE.replace(/\/$/, '')}/${stored}`;
  }
  return stored;
}